export const portfolioData = {
  personal: {
    name: "Guilherme Sanches",
    headline:
      "Full Stack Developer especializado em React, Next.js, Node.js e TypeScript",
    summary:
      "Desenvolvedor Full Stack focado em SaaS e microsserviços. Unindo a bagagem de quem construiu uma comunidade de 170k inscritos à engenharia de software para entregar soluções escaláveis e centradas na UX.",
    location: "São Paulo, Brasil",
    email: "guilhermesanchesdev@gmail.com",
    phone: "+55 (11) 93149-1332",
    social: {
      github: "https://github.com/devgsanches",
      linkedin: "https://www.linkedin.com/in/guilhermesanches-dev/",
      cv: "https://drive.google.com/file/d/1Qj6nDaNyuo-F91KmrEcJyd1pWSkBLH0R/view",
    },
  },
  navLinks: [
    { label: "Experiência", href: "#experience" },
    { label: "Skills", href: "#skills" },
    { label: "Projetos", href: "#projects" },
    { label: "Atividades", href: "#activities" },
    { label: "Educação", href: "#education" },
    { label: "Contato", href: "#contact" },
  ],
  experience: [
    {
      role: "Full Stack Developer",
      company: "Flapper",
      period: "Jan 2025 - Presente",
      location: "São Paulo, Brasil",
      current: true,
      bullets: [
        "Responsável pelo desenvolvimento full-stack de um SaaS para o setor de aviação executiva, desde a arquitetura até o deploy em produção, utilizando React, Next.js, TypeScript, Node.js, AdonisJS e MySQL.",
        "Implementei sistemas de notificação e comunicação em real-time com WebSocket, push notifications e integrações com serviços de mensageria, melhorando o engajamento dos usuários na plataforma.",
        "Conduzi a reconstrução (v2) de um módulo crítico do site principal, os voos compartilhados, substituindo o sistema legado por uma nova arquitetura, com melhoria na experiência do usuário e taxa de conversão.",
        "Desenvolvi APIs REST, integrações com serviços AWS (Lambda, SQS, EventBridge), pipelines de CI/CD e fluxos de mensageria com RabbitMQ em arquitetura de microsserviços.",
        "Colaborei com equipes de produto, design e operações em decisões de arquitetura, escalabilidade e code reviews.",
      ],
      skills: [
        "React",
        "Next.js",
        "TypeScript",
        "Node.js",
        "AdonisJS",
        "MySQL",
        "AWS",
        "RabbitMQ",
        "WebSocket",
        "Docker",
        "CI/CD",
      ],
    },
    {
      role: "Estágio - Desenvolvimento Web",
      company: "Madeira de Demolição",
      period: "Set 2024 - Dez 2024",
      location: "São Paulo, Brasil",
      current: false,
      bullets: [
        "Responsável pela manutenção e evolução contínua do site institucional da empresa, desenvolvido com WordPress e Elementor, garantindo estabilidade e atualização do conteúdo.",
        "Criei e publiquei landing pages para lançamentos de novos produtos e campanhas, com foco em conversão e alinhamento com a identidade visual da marca.",
        "Implementei melhorias de performance, SEO e usabilidade no site principal, contribuindo para melhor experiência do usuário e visibilidade nos mecanismos de busca.",
      ],
      skills: ["WordPress", "Elementor", "SEO", "Landing Pages", "HTML", "CSS"],
    },
  ],
  skills: {
    "Front-end": [
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "React",
      "React Native",
      "Next.js",
      "TailwindCSS",
      "Shadcn UI",
      "Zustand",
      "Context API",
      "React Query",
      "Testing Library",
    ],
    "Back-end": [
      "Node.js",
      "Express",
      "NestJS",
      "AdonisJS",
      "REST APIs",
      "WebSocket",
    ],
    Testes: ["Testes Unitários", "Testes de Integração (TDD)", "Testes E2E"],
    "Cloud e DevOps": [
      "AWS",
      "Lambda",
      "SQS",
      "EventBridge",
      "Docker",
      "Kubernetes",
      "CI/CD",
      "RabbitMQ",
    ],
    "Banco de Dados": ["SQL", "NoSQL", "MySQL", "Redis"],
    Arquitetura: ["Microsserviços", "Sistemas Distribuídos", "Full-Stack"],
  },
  projects: [
    {
      title: "The Jet Society - Back-office e API",
      description:
        "SaaS de gestão de aviação executiva desenvolvido do zero. Back-office com Next.js 15, React 19, TypeScript, TailwindCSS e Shadcn UI. API com AdonisJS 6, MySQL, Redis e WebSocket. Gestão de contratos fracionados, reservas de voo, equivalência entre modelos de aeronaves e controle de horas.",
      tags: [
        "Next.js",
        "React",
        "TypeScript",
        "AdonisJS",
        "MySQL",
        "WebSocket",
      ],
      link: null,
      linkLabel: "Repositório privado",
    },
    {
      title: "The Jet Society - Landing Page",
      description:
        "Landing page institucional com foco em conversão, SEO e performance. Score Lighthouse: Performance 98, SEO acima de 95.",
      tags: ["Next.js", "TailwindCSS", "SEO", "Lighthouse"],
      link: "https://tjs-lp.vercel.app",
      linkLabel: "Ver projeto",
    },
    {
      title: "Voos Compartilhados V2",
      description:
        "Reconstrução completa do módulo de voos compartilhados do site principal da Flapper, substituindo sistema legado por nova arquitetura com melhoria na taxa de conversão.",
      tags: ["React", "Next.js", "TypeScript", "Conversão"],
      link: "https://flyflapper.com",
      linkLabel: "Ver projeto",
    },
  ],
  activities: [
    {
      text: "Criador de conteúdo no YouTube (2020-2024), canal com 170 mil inscritos e placa de prata (100k), produzindo conteúdo diário incluindo lives e eventos.",
      icon: "youtube",
    },
    {
      text: "+12 certificações concluídas em plataformas como Rocketseat e Full Stack Club, com foco em React, Node.js, TypeScript e desenvolvimento full-stack.",
      icon: "award",
    },
    {
      text: "Estudante de Inglês, com foco em fluência profissional.",
      icon: "languages",
    },
    {
      text: "Leitura frequente de livros técnicos, desde engenharia de software a desenvolvimento pessoal.",
      icon: "book",
    },
  ],
  education: [
    {
      degree: "Bacharelado em Sistemas de Informação",
      institution: "Faculdade das Américas",
      period: "Jun 2024 - Jun 2028",
      highlight: "Em andamento",
    },
    {
      degree: "Ensino Médio Completo",
      institution: "Colégio Evangélico de Itaquera",
      period: "Conclusão em 2023",
      highlight: null,
    },
  ],
  lastUpdated: "2026-04-20",
};
